import { http } from "./http";

export interface Exchange {
    ratedate: string;
    ccy: string;
    ccyName: string;
    buyrate: string;
    sellrate: string;
    cbrate: string;
    buyTrend: string;
    sellTrend: string;
    cbTrend : string;
};

export const getCurrencyExchange = async (): Promise<Exchange[]> => {
    const { data } = await http.get<Exchange[]>(`exchange/exchange/listrates`);
    return data;
};
